export const encodeQueryData = (data) => {
  const ret = [];
  for (let d in data) ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
};

export const strRemoveDelimiterToNumber = (string = '') => {
  const delimiterRemoved = string?.replace?.(/\./g, '');

  if (delimiterRemoved) return Number(delimiterRemoved);
  return undefined;
};

export const formatPaymentType = (input) => {
  return input?.replace(/_/g, ' ')?.replace(/\b\w/g, (char) => char?.toUpperCase());
};
